module.exports = __webpack_public_path__ + "static/img/so2_2.5d1e390.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/solution/pic/so2_2.jpg
// module id = k40h
// module chunks = 11